import React from "react";

export const Microphone = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="MicrophoneStage" clipPath="url(#clip0_1790_363)">
        <path
          id="Vector"
          d="M13.125 11.875C15.8864 11.875 18.125 9.63642 18.125 6.875C18.125 4.11358 15.8864 1.875 13.125 1.875C10.3636 1.875 8.125 4.11358 8.125 6.875C8.125 9.63642 10.3636 11.875 13.125 11.875Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M16.6602 10.4102L9.58984 3.33984"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M7.5 12.5L8.125 11.875"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_4"
          d="M8.20312 7.77344L2.62109 15.3906C2.53293 15.5109 2.49069 15.6588 2.50201 15.8075C2.51333 15.9562 2.57746 16.096 2.68281 16.2016L3.8 17.3187C3.90557 17.4241 4.04534 17.4882 4.19406 17.4996C4.34278 17.5109 4.49064 17.4686 4.61094 17.3805L12.2266 11.7969"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1790_363">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
